import { TOGGLE_SERVICE } from './constants';

const initialState = {
  activeServiceIds: [],
};

// FIXME: make serviceId toggler, just setting it to last added service won't do
export default function (state = initialState, action) {
  switch (action.type) {
    case TOGGLE_SERVICE: {
      const { activeServiceIds } = action;
      return { ...state, activeServiceIds };
    }
    default:
      return state;
  }
}
